import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

import { petrol } from '../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconSettingsComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest} strokeWidth={1.5}>
      <path
        d="M9.6 4c0-.6.6-1 1.1-1h2.6c.5 0 1 .4 1.1 1l.2 1.2c0 .4.3.7.7.9l.2.1c.3.2.7.3 1 .1l1.3-.4a1.1 1.1 0 0 1 1.3.5l1.3 2.2a1.1 1.1 0 0 1-.2 1.5l-1 .8c-.3.2-.5.6-.5 1a6.8 6.8 0 0 1 0 .2c0 .4.2.8.5 1l1 .8c.4.4.5 1 .2 1.5l-1.3 2.2a1.1 1.1 0 0 1-1.3.5l-1.2-.4c-.4-.2-.8-.1-1.1 0a6.6 6.6 0 0 1-.2.2c-.4.2-.6.5-.7.9l-.2 1.3c0 .5-.6.9-1.1.9h-2.6c-.5 0-1-.4-1.1-1l-.2-1.2c0-.4-.3-.7-.7-.9a6.5 6.5 0 0 1-.2-.1c-.3-.2-.7-.3-1-.1l-1.3.4a1.1 1.1 0 0 1-1.3-.5l-1.3-2.2a1.1 1.1 0 0 1 .2-1.5l1-.8c.3-.2.5-.6.5-1a7 7 0 0 1 0-.2c0-.4-.2-.8-.5-1l-1-.8a1.1 1.1 0 0 1-.2-1.5l1.3-2.2a1.1 1.1 0 0 1 1.3-.5l1.2.4c.4.2.8.1 1.1 0l.2-.2c.4-.2.6-.5.7-.9L9.6 4z"
        fill="none"
        stroke="currentColor"
      />
      <path d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" fill="none" stroke="currentColor" />
    </SvgIcon>
  );
};

IconSettingsComponent.displayName = 'IconSettings';

const IconSettings = memo(IconSettingsComponent);

export default IconSettings;
